/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';
import WordCloudColours from 'shared/ui/components/live-sessions/settings/WordCloudColours.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';

import { cloneDeep } from 'lodash';

/**
 * @typedef {object} OptionsValue
 *
 * @property {boolean} clappingEnabled
 * @property {boolean} qnaEnabled
 * @property {boolean} qnaModerationEnabled
 * @property {boolean} qnaAnonymousEnabled
 * @property {boolean} qnaUpvotingEnabled
 */

const __vue_script__ = {
    name: 'InteractivityOptions',

    components: {
        BaseInput,
        Toggler,
        WordCloudColours,
        TargetingControl
    },

    props: {
        value: {
            type: Object,
            required: true
        },

        liveStream: {
            type: Object,
            default: () => null
        },

        showPollsOption: {
            type: Boolean,
            default: false
        },

        showWordCloudColors: {
            type: Boolean,
            default: false
        },

        showTargeting: {
            type: Boolean,
            default: false
        },

        showQnaModerationOption: {
            type: Boolean,
            default: false
        },

        showClapsOption: {
            type: Boolean,
            default: false
        },

        eventId: {
            type: String,
            default: ''
        },

        showQnaUpvotingOption: {
            type: Boolean,
            default: false
        },

        showPollNotificationOption: {
            type: Boolean,
            default: true
        },

        showPrivateQnaOption: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        /** @returns {boolean} */
        showWordCloudOptions() {
            return this.pollsEnabled && this.showWordCloudColors;
        },

        /** @returns {boolean} */
        showPollNotificationToggle() {
            return this.pollsEnabled && this.showPollNotificationOption;
        },

        /** @returns {boolean} */
        showTargetingOptions() {
            return this.pollsEnabled && this.showTargeting;
        },

        clappingEnabled: {
            /** @returns {boolean} */
            get() { return this.value.clappingEnabled; },
            /** @param {boolean} value */
            set(value) { this.$emit('change', { field: 'clappingEnabled', value }); }
        },
        pollsEnabled: {
            /** @returns {boolean} */
            get() { return this.value.pollsEnabled; },
            /** @param {boolean} value */
            set(value) { this.$emit('change', { field: 'pollsEnabled', value }); }
        },
        pollsColours: {
            /** @returns {string[]} */
            get() { return this.value.pollsColours; },
            /** @param {string[]} value */
            set(value) { this.$emit('change', { field: 'pollsColours', value }); }
        },
        pollsNotificationsEnabled: {
            /** @returns {boolean} */
            get() { return this.value.pollsNotificationsEnabled; },
            /** @param {boolean} value */
            set(value) { this.$emit('change', { field: 'pollsNotificationsEnabled', value }); }
        },
        qnaEnabled: {
            /** @returns {boolean} */
            get() { return this.value.qnaEnabled; },
            /** @param {boolean} value */
            set(value) { this.$emit('change', { field: 'qnaEnabled', value }); }
        },
        qnaModerationEnabled: {
            /** @returns {boolean} */
            get() { return this.value.qnaModerationEnabled; },
            /** @param {boolean} value */
            set(value) { this.$emit('change', { field: 'qnaModerationEnabled', value }); }
        },
        qnaAnonymousEnabled: {
            /** @returns {boolean} */
            get() { return this.value.qnaAnonymousEnabled; },
            /** @param {boolean} value */
            set(value) { this.$emit('change', { field: 'qnaAnonymousEnabled', value }); }
        },
        qnaUpvotingEnabled: {
            /** @returns {boolean} */
            get() { return this.value.qnaUpvotingEnabled; },
            /** @param {boolean} value */
            set(value) {
                this.$emit('change', { field: 'qnaUpvotingEnabled', value });
                if (value) {
                    this.$emit('change', { field: 'qnaPrivateEnabled', value: false });
                }
            }
        },
        qnaPrivateEnabled: {
            /** @returns {boolean} */
            get() { return this.value.qnaPrivateEnabled; },
            /** @param {boolean} value */
            set(value) {
                this.$emit('change', { field: 'qnaPrivateEnabled', value });
                if (value) {
                    this.$emit('change', { field: 'qnaUpvotingEnabled', value: false });
                }
            }
        },

        targeting: {
            /** @returns {object} */
            get() { return cloneDeep(this.value.targeting); },
            /** @param {object} value */
            set(value) {
                this.$emit('change', { value, field: 'targeting' });
            },
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "interactivity-options" },
    [
      _c(
        "validation-provider",
        { attrs: { slim: true } },
        [
          _c(
            "toggler",
            {
              attrs: {
                name: "qna",
                "on-label": "live_sessions.form.qna",
                "off-label": "live_sessions.form.qna",
              },
              model: {
                value: _vm.qnaEnabled,
                callback: function ($$v) {
                  _vm.qnaEnabled = $$v
                },
                expression: "qnaEnabled",
              },
            },
            [
              _vm.qnaEnabled
                ? _c(
                    "div",
                    { staticClass: "feature-dependant" },
                    [
                      _c(
                        "validation-provider",
                        { attrs: { slim: true } },
                        [
                          _vm.showQnaModerationOption
                            ? _c("toggler", {
                                attrs: {
                                  name: "qna_moderated",
                                  "on-label":
                                    "live_sessions.form.qna_moderated",
                                  "off-label":
                                    "live_sessions.form.qna_moderated",
                                },
                                model: {
                                  value: _vm.qnaModerationEnabled,
                                  callback: function ($$v) {
                                    _vm.qnaModerationEnabled = $$v
                                  },
                                  expression: "qnaModerationEnabled",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "validation-provider",
                        { attrs: { slim: true } },
                        [
                          _vm.showQnaUpvotingOption
                            ? _c("toggler", {
                                attrs: {
                                  name: "qna_upvoting",
                                  "on-label": "live_sessions.form.qna_upvoting",
                                  "off-label":
                                    "live_sessions.form.qna_upvoting",
                                },
                                model: {
                                  value: _vm.qnaUpvotingEnabled,
                                  callback: function ($$v) {
                                    _vm.qnaUpvotingEnabled = $$v
                                  },
                                  expression: "qnaUpvotingEnabled",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "validation-provider",
                        { attrs: { slim: true } },
                        [
                          _c("toggler", {
                            attrs: {
                              name: "qna_anonymous",
                              "on-label": "live_sessions.form.qna_anonymous",
                              "off-label": "live_sessions.form.qna_anonymous",
                            },
                            model: {
                              value: _vm.qnaAnonymousEnabled,
                              callback: function ($$v) {
                                _vm.qnaAnonymousEnabled = $$v
                              },
                              expression: "qnaAnonymousEnabled",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.showPrivateQnaOption
                        ? _c(
                            "validation-provider",
                            { attrs: { slim: true } },
                            [
                              _c("toggler", {
                                attrs: {
                                  name: "qna_private",
                                  "on-label": "live_sessions.form.qna_private",
                                  "off-label": "live_sessions.form.qna_private",
                                },
                                model: {
                                  value: _vm.qnaPrivateEnabled,
                                  callback: function ($$v) {
                                    _vm.qnaPrivateEnabled = $$v
                                  },
                                  expression: "qnaPrivateEnabled",
                                },
                              }),
                              _c("div", { staticClass: "control-hint" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "live_sessions.form.qna_private_subtitle"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "validation-provider",
        { attrs: { slim: true } },
        [
          _vm.showPollsOption
            ? _c(
                "toggler",
                {
                  attrs: {
                    name: "polls",
                    "on-label": "live_sessions.form.polls",
                    "off-label": "live_sessions.form.polls",
                  },
                  model: {
                    value: _vm.pollsEnabled,
                    callback: function ($$v) {
                      _vm.pollsEnabled = $$v
                    },
                    expression: "pollsEnabled",
                  },
                },
                [
                  _vm.showPollNotificationToggle
                    ? _c(
                        "div",
                        { staticClass: "feature-dependant" },
                        [
                          _c(
                            "validation-provider",
                            { attrs: { slim: true } },
                            [
                              _c("toggler", {
                                attrs: {
                                  name: "polls_notifications_enabled",
                                  "on-label":
                                    "live_sessions.form.polls_notifications_enabled",
                                  "off-label":
                                    "live_sessions.form.polls_notifications_enabled",
                                },
                                model: {
                                  value: _vm.pollsNotificationsEnabled,
                                  callback: function ($$v) {
                                    _vm.pollsNotificationsEnabled = $$v
                                  },
                                  expression: "pollsNotificationsEnabled",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showWordCloudOptions
        ? _c("word-cloud-colours", {
            attrs: {
              name: "polls_colours",
              label: "live_sessions.form.polls_colours",
              hint: "live_sessions.form.polls_colours_hint",
            },
            model: {
              value: _vm.pollsColours,
              callback: function ($$v) {
                _vm.pollsColours = $$v
              },
              expression: "pollsColours",
            },
          })
        : _vm._e(),
      _c(
        "validation-provider",
        { attrs: { slim: true } },
        [
          _vm.showClapsOption
            ? _c("toggler", {
                attrs: {
                  name: "clapping",
                  "on-label": "live_sessions.form.clapping",
                  "off-label": "live_sessions.form.clapping",
                },
                model: {
                  value: _vm.clappingEnabled,
                  callback: function ($$v) {
                    _vm.clappingEnabled = $$v
                  },
                  expression: "clappingEnabled",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.showTargetingOptions
        ? _c(
            "validation-provider",
            { attrs: { name: "targeting", slim: true } },
            [
              _c("targeting-control", {
                attrs: {
                  name: "targeting",
                  label: _vm.$t("live_sessions.form.targeting"),
                  hint: _vm.$t("live_sessions.form.targeting_hint"),
                  "event-id": _vm.eventId,
                },
                model: {
                  value: _vm.targeting,
                  callback: function ($$v) {
                    _vm.targeting = $$v
                  },
                  expression: "targeting",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/live-sessions/settings/InteractivityOptions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__